module.exports = __webpack_public_path__ + "img/androidPad.cada30af.png";